import get from './methods/get';
import put from './methods/put';

export default {
	get: headers => get('periodicalPayments', headers),
	put: (agreementId, body, headers) =>
		put('periodicalPayments/' + agreementId, body, headers),
};
